import React from "react";
import "./VoyahTaishan.css";
import VoyahTaishanHero from "../../components/pages/VoyahTaishan/VoyahTaishanHero/VoyahTaishanHero";
import VoyahTaishanWarranty from "../../components/pages/VoyahTaishan/VoyahTaishanWarranty/VoyahTaishanWarranty";
import VoyahTaishanExteriorInterior from "../../components/pages/VoyahTaishan/VoyahTaishanExteriorInterior/VoyahTaishanExteriorInterior";
import VoyahTaishanExtras from "../../components/pages/VoyahTaishan/VoyahTaishanExtras/VoyahTaishanExtras";
import VoyahTaishanFeatures from "../../components/pages/VoyahTaishan/VoyahTaishanFeatures/VoyahTaishanFeatures";
import Footer2 from "../../components/pages/VoyahFree/Footer2";
import BackToVehicleModels from "../../components/BackToVehicleModels/BackToVehicleModels";
import VoyahTaishanTechnicalSpecs from "../../components/pages/VoyahTaishan/VoyahTaishanTechnicalSpecs/VoyahTaishanTechnicalSpecs";

const VoyahTaishan = () => {
  return (
    <div className="vtpage">
      <VoyahTaishanHero />
      <VoyahTaishanTechnicalSpecs />
      <VoyahTaishanWarranty />
      <VoyahTaishanExteriorInterior />
      <VoyahTaishanExtras />
      <VoyahTaishanFeatures />
      <BackToVehicleModels variant="violet" />
      <Footer2 />
    </div>
  );
};

export default VoyahTaishan;
